"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJWTToken = getJWTToken;
exports.decodeJWT = decodeJWT;
exports.isJWTExpired = isJWTExpired;
exports.removeJWTToken = removeJWTToken;
exports.setJWTToken = setJWTToken;
const dayjs_1 = __importDefault(require("dayjs"));
const jwt_decode_1 = require("jwt-decode");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
function getJWTToken() {
    const authTokenStr = localStorage.getItem(sonar_ts_types_1.LocalStorageKey.AuthToken);
    if (!authTokenStr) {
        return;
    }
    const authTokenObj = JSON.parse(authTokenStr);
    const { token } = authTokenObj;
    return token;
}
function decodeJWT() {
    const token = getJWTToken();
    return (0, jwt_decode_1.jwtDecode)(token || '');
}
function isJWTExpired(exprationInSeconds) {
    const unixTimestamp = (0, dayjs_1.default)().unix();
    return (0, dayjs_1.default)(exprationInSeconds).isAfter(unixTimestamp);
}
function removeJWTToken() {
    localStorage.removeItem(sonar_ts_types_1.LocalStorageKey.AuthToken);
}
function setJWTToken(token) {
    localStorage.setItem(sonar_ts_types_1.LocalStorageKey.AuthToken, JSON.stringify({ token }));
}
//# sourceMappingURL=lib.js.map